// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookkeepers-by-zipcode {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 30px;
}

.back-link {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.9rem;
  margin-bottom: 10px;
  display: inline-block;
}

.back-link:hover {
  color: #374151;
}

.page-header h1 {
  color: #1f2937;
  margin-bottom: 8px;
  font-size: 2rem;
}

.page-header p {
  color: #6b7280;
  font-size: 1.1rem;
}

.zipcode-overview {
  margin-bottom: 30px;
}

.overview-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
}

.overview-stat {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-top: 4px solid #3b82f6;
}

.overview-stat.approved {
  border-top-color: #10b981;
}

.overview-stat.pending {
  border-top-color: #f59e0b;
}

.overview-stat.expired {
  border-top-color: #ef4444;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 4px;
}

.stat-label {
  color: #6b7280;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filters-section {
  margin-bottom: 20px;
}

.status-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-btn {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.filter-btn:hover {
  background: #f9fafb;
}

.filter-btn.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.filter-btn.approved.active {
  background: #10b981;
  border-color: #10b981;
}

.filter-btn.pending.active {
  background: #f59e0b;
  border-color: #f59e0b;
}

.filter-btn.expired.active {
  background: #ef4444;
  border-color: #ef4444;
}

.bookkeepers-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 20px;
}

.bookkeepers-table {
  width: 100%;
  border-collapse: collapse;
}

.bookkeepers-table th {
  background: #f8fafc;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.bookkeepers-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.bookkeeper-row:hover {
  background: #f8fafc;
}

.name-cell {
  font-weight: 600;
}

.contact-info {
  font-size: 0.9rem;
}

.email, .phone {
  margin-bottom: 2px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.approved {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.pending {
  background: #fef3c7;
  color: #92400e;
}

.status-badge.expired {
  background: #fee2e2;
  color: #991b1b;
}

.status-badge.rejected {
  background: #f3f4f6;
  color: #374151;
}

.action-buttons {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.action-buttons button,
.action-buttons a {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
}

.btn-approve {
  background: #10b981;
  color: white;
}

.btn-approve:hover {
  background: #059669;
}

.btn-reject {
  background: #ef4444;
  color: white;
}

.btn-reject:hover {
  background: #dc2626;
}

.btn-extend {
  background: #f59e0b;
  color: white;
}

.btn-extend:hover {
  background: #d97706;
}

.btn-view {
  background: #3b82f6;
  color: white;
}

.btn-view:hover {
  background: #2563eb;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.pagination-btn {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn:hover:not(:disabled) {
  background: #f9fafb;
}

.page-info {
  color: #6b7280;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .bookkeepers-by-zipcode {
    padding: 10px;
  }
  
  .overview-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .status-filters {
    justify-content: center;
  }
  
  .bookkeepers-table {
    font-size: 0.8rem;
  }
  
  .bookkeepers-table th,
  .bookkeepers-table td {
    padding: 8px 12px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .action-buttons button,
  .action-buttons a {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/BookkeepersByZipcode.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".bookkeepers-by-zipcode {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 30px;\n}\n\n.back-link {\n  color: #6b7280;\n  text-decoration: none;\n  font-size: 0.9rem;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n\n.back-link:hover {\n  color: #374151;\n}\n\n.page-header h1 {\n  color: #1f2937;\n  margin-bottom: 8px;\n  font-size: 2rem;\n}\n\n.page-header p {\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.zipcode-overview {\n  margin-bottom: 30px;\n}\n\n.overview-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n}\n\n.overview-stat {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border-top: 4px solid #3b82f6;\n}\n\n.overview-stat.approved {\n  border-top-color: #10b981;\n}\n\n.overview-stat.pending {\n  border-top-color: #f59e0b;\n}\n\n.overview-stat.expired {\n  border-top-color: #ef4444;\n}\n\n.stat-number {\n  display: block;\n  font-size: 2rem;\n  font-weight: bold;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  color: #6b7280;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filters-section {\n  margin-bottom: 20px;\n}\n\n.status-filters {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.filter-btn {\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.filter-btn:hover {\n  background: #f9fafb;\n}\n\n.filter-btn.active {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.filter-btn.approved.active {\n  background: #10b981;\n  border-color: #10b981;\n}\n\n.filter-btn.pending.active {\n  background: #f59e0b;\n  border-color: #f59e0b;\n}\n\n.filter-btn.expired.active {\n  background: #ef4444;\n  border-color: #ef4444;\n}\n\n.bookkeepers-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.bookkeepers-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.bookkeepers-table th {\n  background: #f8fafc;\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.bookkeepers-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.bookkeeper-row:hover {\n  background: #f8fafc;\n}\n\n.name-cell {\n  font-weight: 600;\n}\n\n.contact-info {\n  font-size: 0.9rem;\n}\n\n.email, .phone {\n  margin-bottom: 2px;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.approved {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.expired {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge.rejected {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.action-buttons button,\n.action-buttons a {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.btn-approve {\n  background: #10b981;\n  color: white;\n}\n\n.btn-approve:hover {\n  background: #059669;\n}\n\n.btn-reject {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-reject:hover {\n  background: #dc2626;\n}\n\n.btn-extend {\n  background: #f59e0b;\n  color: white;\n}\n\n.btn-extend:hover {\n  background: #d97706;\n}\n\n.btn-view {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-view:hover {\n  background: #2563eb;\n}\n\n.no-results {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.pagination-btn {\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.page-info {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .bookkeepers-by-zipcode {\n    padding: 10px;\n  }\n  \n  .overview-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .status-filters {\n    justify-content: center;\n  }\n  \n  .bookkeepers-table {\n    font-size: 0.8rem;\n  }\n  \n  .bookkeepers-table th,\n  .bookkeepers-table td {\n    padding: 8px 12px;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .action-buttons button,\n  .action-buttons a {\n    font-size: 0.7rem;\n    padding: 3px 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
